import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { portfolio } from '@/config/portfolio';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Carousel from '@/components/carousel/Carousel';
import './Skills.scss';

export const Skills = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1
    }
  };

  return (
    <section className="skills-section" id="skills" ref={ref}>
      <div className="skills-container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: -20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
          transition={{ duration: 0.6 }}
        >
          {portfolio.skills.title}
        </motion.h2>
        
        <motion.p 
          className="section-subtitle"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {portfolio.skills.subtitle}
        </motion.p>
        
        <motion.div
          className="skills-carousel"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <Carousel ariaLabel="Skills carousel">
            {portfolio.skills.skills.map((skill, index) => (
              <motion.div
                key={index}
                className="skill-card"
                variants={itemVariants}
              >
                <div className="skill-icon">
                  {skill.icon && <FontAwesomeIcon icon={skill.icon} />}
                </div>
                <h3>{skill.name}</h3>
                <p>{skill.description}</p>
              </motion.div>
            ))}
          </Carousel>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
